module.exports = __webpack_public_path__ + "img/193.b52b9b63.jpg";